import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { withTranslation } from 'react-i18next'
import { isIE } from 'react-device-detect'

import { getAssetsUrl } from 'helpers/getAssetsUrl'
import './styles.scss'

const baseClass = 'no-activities'

const NoActivitiesComponent = ({ t, topText, bottomText, imageSrc, customClass }) => (
  <div className={baseClass}>
    <div
      className={cn(`${baseClass}__inner`, {
        [`${baseClass}__inner--${customClass}`]: customClass,
      })}
    >
      <div
        className={cn(`${baseClass}__top-text`, {
          [`${baseClass}__top-text-ie`]: isIE,
          [`${baseClass}__top-text--${customClass}`]: customClass,
        })}
      >
        {t(topText)}
      </div>
      <img
        className={cn(`${baseClass}__image`, {
          [`${baseClass}__image--${customClass}`]: customClass,
        })}
        src={getAssetsUrl('users/52cdf99c-6bb4-449a-b8a7-1ea2811c6a3b.png')}
        alt="No activities"
      />
      <p
        className={cn(`${baseClass}__bottom-text`, {
          [`${baseClass}__bottom-text--${customClass}`]: customClass,
        })}
      >
        {bottomText && t(bottomText)}
      </p>
    </div>
    {imageSrc && <img className={`${baseClass}__button-image`} src={getAssetsUrl(imageSrc)} alt={t('Add favorites')} />}
  </div>
)
NoActivitiesComponent.propTypes = {
  topText: PropTypes.string,
  bottomText: PropTypes.string,
  imageSrc: PropTypes.string,
  customClass: PropTypes.string,
}

NoActivitiesComponent.displayName = 'NoActivitiesComponent'

export default withTranslation('user')(NoActivitiesComponent)
